import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './projectDetail.module.scss';
import location from '../../static/images_pfizer/assistant/location.png';
import arrow_down from '../../static/images_pfizer/assistant/arrow_down.png';
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png';
import project_card from '../../static/images_pfizer/assistant/project_card.png';
import project_icon from '../../static/images_pfizer/assistant/project_icon.png';
import invite_doctor from '../../static/images_pfizer/assistant/invite_doctor.png';
import  { ApiCore } from '../../api/index';
import { withRouter } from 'react-router-dom';
import utils from '../../utils/utils';

const api = new ApiCore();

function ProjectDetail(props: any) {
    
    const [list, setList] = useState([]);
    const [groupName, setGroupName] = useState('');

    useEffect(() => {
        getTeamDoctors();
        return () => {
        }
    }, [])

    const getTeamDoctors = () => {
        const urlParams = utils.getUrlParams();
        if (urlParams.groupName) {
            setGroupName(urlParams.groupName);
        }
        if (urlParams.groupCode) {
            const param = {
                groupCode: urlParams.groupCode
            }
            api.getTeamDoctors(param).then((res: any) => {
                if (res.code == 0) {
                    setList(res.data || []);
                }
            })
        }
    }

    return (
        <div className={`${styles.projectDetail_content}`}>

            <div className={`${styles.patient_head_outer}`}>
                <div className={`${styles.patient_head_card}`}>
                        <img src={project_icon} className={styles.icon} alt="" />
                        <div className={styles.text} >{groupName}</div>
                        <img src={project_card} className={styles.arrow_down}  alt="" />
                </div>
            </div>
            <div className={`${styles.project_doctor}`}>项目医生</div>
            <div className={`${styles.project_doctor_info}`} onClick={()=> { props.history.push('/pfizer/assistant/addDoctor') }}>
                <img src={invite_doctor} alt="" />
                <span>邀请医生</span>
            </div>
            {
                list && list.map((val: any, key: number) => (
                <div key={key} className={styles.head_content}>
                    <div className={styles.content_card}>
                        <div className={styles.card_top}>
                            <div className={styles.top_left}>
                                <img src={assistant_doctor_avatar} alt="" />
                            </div>
                            <div className={styles.top_middle}>
                                <div className={styles.top_middle_head}>
                                    <span>{val.doctorName}</span>
                                    <span>{val.jobTitle}</span>
                                </div>
                                <div className={styles.top_middle_middle}>
                                    <span>{val.hospital}</span>
                                    <span>{val.dept}</span>
                                </div>
                                {
                                    (val.groupTasks || []).map((item: any) => (
                                        <div className={styles.top_middle_bottom}>{item.groupName || ''}</div>
                                    ))
                                }
                            </div>
                            {/* {
                                val.state &&
                                <div className={styles.top_right}>
                                    <div className={styles.top_right_button}>活跃中</div>
                                </div>
                            } */}
                        </div>
                        {/* <div className={styles.card_middle_line}></div>
                        <div className={styles.card_bottom}>
                            <div className={styles.bottom_left}>
                                <div>NP / OP</div>
                                <div>26 / 33</div>
                            </div>
                            <div className={styles.bottom_right}>
                                <div>任务</div>
                                <div>15 / 30</div>
                            </div>
                        </div> */}
                    </div>
                </div>
                ))
            }
            {/* {
                groupList && groupList.map((val: any, key: number) => (
                    <div key={key} className={`${styles.project_list_item}`}>
                        <div className={styles.title_wrap}>
                            <div className={styles.border}></div>
                            <div className={styles.title}>{val.groupName}</div>
                        </div>
                        <div className={styles.np_op}>
                            <span className={styles.np_op_title}>NP / OP</span>
                            <span className={styles.np_op_number}>{val.npNum} / {val.opNum}</span>
                        </div>
                    </div>
                ))
            } */}
        </div>
    )

}

export default withRouter(ProjectDetail);